import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdditionalUploadingTemplate = _resolveComponent("AdditionalUploadingTemplate")!

  return (_openBlock(), _createBlock(_component_AdditionalUploadingTemplate, {
    title: "Дозагрузка Газ (Беларусь, Казахстан, Армения)",
    apiUrl: "api/additionaluploading/uploadgas",
    permissionCode: _ctx.getPermissionCode,
    type: _ctx.getType
  }, null, 8, ["permissionCode", "type"]))
}